(function () {
  'use strict';

  var config = window.__themeAppScriptConfig;
  if (!config) return;

  var deferred = [];
  var activated = false;
  var cardJudgeSelectors = [
    '.card-wrapper .jdgm-widget',
    '.card-wrapper .jdgm-preview-badge',
    '.card-wrapper .jdgm-prev-badge',
    '.card-main-wrapper .jdgm-widget',
    '.card-main-wrapper .jdgm-preview-badge',
    '.card-main-wrapper .jdgm-prev-badge',
    'product-info[data-layout="card"] .jdgm-widget',
    'product-info[data-layout="card"] .jdgm-preview-badge',
    'product-info[data-layout="card"] .jdgm-prev-badge',
    '.complementary-slide .jdgm-widget',
    '.complementary-slide .jdgm-preview-badge',
    '.related-products .jdgm-widget',
    '.related-products .jdgm-preview-badge',
    '.product-grid .jdgm-preview-badge',
    '.product-grid .jdgm-widget.jdgm-preview-badge'
  ].join(',');

  function matches(url, patterns) {
    if (!url) return false;
    return patterns.some(function (pattern) {
      return url.indexOf(pattern) !== -1;
    });
  }

  function shouldAllow(kind) {
    if (kind === 'offerly') return config.allowOfferly;
    if (kind === 'judge') return config.allowJudge;
    if (kind === 'smile') return config.allowSmile;
    return true;
  }

  function shouldDefer(kind) {
    if (kind === 'offerly') return config.deferOfferly;
    if (kind === 'smile') return config.deferSmile;
    return false;
  }

  function detectKind(url) {
    if (matches(url, config.patterns.offerly)) return 'offerly';
    if (matches(url, config.patterns.judge)) return 'judge';
    if (matches(url, config.patterns.smile)) return 'smile';
    return null;
  }

  function hideOfferlyUi() {
    document.querySelectorAll('[class*="offerly"], [id*="offerly"], [class*="Offerly"]').forEach(function (node) {
      node.setAttribute('hidden', 'hidden');
      node.setAttribute('aria-hidden', 'true');
      node.style.setProperty('display', 'none', 'important');
    });
  }

  function patchJudgeSettings(settings) {
    if (!settings || typeof settings !== 'object') return;
    settings.preview_badge_collection_page_install_preference = false;
    settings.preview_badge_collection_page_install_status = false;
    settings.preview_badge_home_page_install_preference = false;
    settings.badge_collection_page_install_status = false;
  }

  function limitJudgeCardWidgets() {
    if (window.jdgmSettings) patchJudgeSettings(window.jdgmSettings);

    document.querySelectorAll(cardJudgeSelectors).forEach(function (node) {
      if (node.parentNode) node.parentNode.removeChild(node);
    });
  }

  function loadDeferredScript(record) {
    var script = document.createElement('script');
    script.src = record.src;
    if (record.type) script.type = record.type;
    if (record.async) script.async = true;
    if (record.defer) script.defer = true;
    if (record.id) script.id = record.id;
    if (record.dataset) {
      Object.keys(record.dataset).forEach(function (key) {
        script.dataset[key] = record.dataset[key];
      });
    }
    document.head.appendChild(script);
  }

  function loadDeferredStylesheet(record) {
    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = record.href;
    if (record.media) link.media = record.media;
    document.head.appendChild(link);
  }

  function activateDeferred() {
    if (activated) return;
    activated = true;

    deferred.forEach(function (record) {
      if (record.kind === 'script') loadDeferredScript(record);
      if (record.kind === 'stylesheet') loadDeferredStylesheet(record);
    });
    deferred = [];
  }

  function scheduleActivation() {
    var run = function () {
      activateDeferred();
    };

    if ('requestIdleCallback' in window) {
      requestIdleCallback(run, { timeout: 3000 });
      return;
    }

    window.setTimeout(run, 1500);
  }

  function deferScript(node) {
    deferred.push({
      kind: 'script',
      src: node.src,
      type: node.type || 'text/javascript',
      async: node.async,
      defer: node.defer,
      id: node.id,
      dataset: Object.assign({}, node.dataset)
    });
    node.parentNode && node.parentNode.removeChild(node);
  }

  function deferStylesheet(node) {
    deferred.push({
      kind: 'stylesheet',
      href: node.href,
      media: node.media || 'all'
    });
    node.parentNode && node.parentNode.removeChild(node);
  }

  function processInlineScript(node) {
    if (node.src) return;
    var text = node.textContent || '';
    if (!config.allowJudge && (node.classList.contains('jdgm-settings-script') || text.indexOf('jdgmSettings') !== -1 || text.indexOf('jdgm.') !== -1)) {
      node.parentNode && node.parentNode.removeChild(node);
      return;
    }
    if (config.allowJudge && (node.classList.contains('jdgm-settings-script') || text.indexOf('jdgmSettings') !== -1)) {
      window.setTimeout(function () {
        patchJudgeSettings(window.jdgmSettings);
      }, 0);
    }
  }

  function processInlineStyle(node) {
    if (!node.classList) return;
    if (!config.allowJudge && node.classList.contains('jdgm-settings-style')) {
      node.parentNode && node.parentNode.removeChild(node);
    }
  }

  function processScript(node) {
    if (!node.src) {
      processInlineScript(node);
      return;
    }
    var kind = detectKind(node.src);
    if (!kind) return;

    if (!shouldAllow(kind)) {
      node.parentNode && node.parentNode.removeChild(node);
      return;
    }

    if (shouldDefer(kind)) {
      deferScript(node);
    }
  }

  function processStylesheet(node) {
    if (!node.href) return;
    var kind = detectKind(node.href);
    if (!kind) return;

    if (!shouldAllow(kind)) {
      node.parentNode && node.parentNode.removeChild(node);
      return;
    }

    if (shouldDefer(kind)) {
      deferStylesheet(node);
    }
  }

  function scan(root) {
    root.querySelectorAll('script').forEach(processScript);
    root.querySelectorAll('link[rel="stylesheet"][href]').forEach(processStylesheet);
    root.querySelectorAll('style').forEach(processInlineStyle);
  }

  function isJudgeCardWidget(node) {
    if (!node || !node.classList) return false;
    if (!(node.classList.contains('jdgm-widget') || node.classList.contains('jdgm-preview-badge') || node.classList.contains('jdgm-prev-badge'))) {
      return false;
    }
    return Boolean(
      node.closest('.card-wrapper, .card-main-wrapper, product-info[data-layout="card"], .complementary-slide, .related-products, .product-grid')
    );
  }

  patchJudgeSettings(window.jdgmSettings);
  scan(document.documentElement);
  limitJudgeCardWidgets();

  if (!config.allowOfferly) {
    hideOfferlyUi();
    document.addEventListener('DOMContentLoaded', hideOfferlyUi);
  }

  document.addEventListener('DOMContentLoaded', limitJudgeCardWidgets);
  window.setTimeout(limitJudgeCardWidgets, 1000);
  window.setTimeout(limitJudgeCardWidgets, 3000);

  if (config.deferOfferly || config.deferSmile) {
    scheduleActivation();
    ['pointerdown', 'keydown', 'touchstart', 'scroll'].forEach(function (eventName) {
      window.addEventListener(eventName, activateDeferred, { once: true, passive: true });
    });
  }

  if (typeof MutationObserver !== 'undefined') {
    var observer = new MutationObserver(function (mutations) {
      var stripCards = false;
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.tagName === 'SCRIPT') processScript(node);
          if (node.tagName === 'LINK') processStylesheet(node);
          if (node.tagName === 'STYLE') processInlineStyle(node);
          if (node.querySelectorAll) scan(node);
          if (!config.allowOfferly && matches(node.className || '', ['offerly', 'Offerly'])) {
            hideOfferlyUi();
          }
          if (isJudgeCardWidget(node) || (node.querySelectorAll && node.querySelector(cardJudgeSelectors))) {
            stripCards = true;
          }
          if (window.jdgmSettings) patchJudgeSettings(window.jdgmSettings);
        });
      });
      if (stripCards) limitJudgeCardWidgets();
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
